module.exports = __webpack_public_path__ + "static/media/SimpleGoodOptimized.05254080.jp2";